<template>
  <div class="contact-view-field-array-of-identifiers flex flex-col gap-md pb-md pt-sm md:pt-sm+">
    <div
      v-for="(identifier, index) in data"
      :key="index"
      class="contact-view-field-identifier-item flex flex-row flex-wrap items-center"
    >
      <div class="text text-ellipsis overflow-hidden mr-md">
        {{ identifier.val }}
      </div>
      <div class="chips-container max-w-full flex flex-row flex-wrap gap-xs">
        <or-tag
          v-for="type of identifier.type"
          :key="type"
        >
          {{ type }}
        </or-tag>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { OrTagV3 as OrTag } from '@onereach/ui-components';
import { defineComponent, PropType } from 'vue';

import { IdentifierValue, SchemaItem } from '@/types';

export default defineComponent({
  name: 'ContactsViewFieldArrayOfIdentifiers',
  components: {
    OrTag,
  },
  props: {
    fieldSchema: {
      type: Object as PropType<SchemaItem>,
      required: true,
    },
    data: {
      type: Array as PropType<IdentifierValue[]>,
      required: false,
      default: () => [],
    },
  },
});
</script>
